import React from 'react';
import './Contact.css';

function Contact() {
  return (
    <div className="contact-page">

      {/* Hero Image */}
      <div className="contact-hero-image">
        <img src="/images/contact-hero.png" alt="Contact Sharanga Aqua Farms" />
      </div>

      {/* Contact Section */}
      <section className="contact-container">
        <div className="contact-left-cards">

          <div className="card-block">
            <div className="icon">
              <img src="/images/location.png" alt="Location Icon" />
            </div>
            <h4>Address</h4>
            <p>
              <a
                href="https://www.google.com/maps/place/Kothota,+Andhra+Pradesh+534281"
                target="_blank"
                rel="noopener noreferrer"
              >
                H.No. 3-74, Kothota, Mutyala Palli, Mogalthuru,<br />
                West Godavari, Andhra Pradesh – 534281
              </a>
            </p>
          </div>

          <div className="card-block">
            <div className="icon">
              <img src="/images/phone.png" alt="Phone Icon" />
            </div>
            <h4>Phone</h4>
            <p>
              <a
                href="https://wa.me/919985435789"
                target="_blank"
                rel="noopener noreferrer"
              >
                +91 9985435789
              </a>
              <br />
              <a
                href="https://wa.me/918186085043"
                target="_blank"
                rel="noopener noreferrer"
              >
                +91 81860 85043
              </a>
            </p>
          </div>

          <div className="card-block">
            <div className="icon">
              <img src="/images/phone1.png" alt="Mobile Icon" />
            </div>
            <h4>Mobile</h4>
            <p>
              <a
                href="https://wa.me/919985435789"
                target="_blank"
                rel="noopener noreferrer"
              >
                +91 9985435789
              </a>
            </p>
          </div>

          <div className="card-block">
            <div className="icon">
              <img src="/images/email.png" alt="Email Icon" />
            </div>
            <h4>Email</h4>
            <p>
              <a href="mailto:info@sharangaaqua.com">info@sharangaaqua.com</a>
            </p>
          </div>

        </div>

        <div className="contact-right-form">
          <h2>Get In Touch</h2>
          <form>
            <input type="text" placeholder="Name" required />
            <input type="email" placeholder="Email" required />
            <input type="text" placeholder="Subject" required />
            <textarea rows="5" placeholder="Message" required></textarea>
            <button type="submit">Send Message</button>
          </form>
        </div>
      </section>

     {/* Map Section with Image and Address */}
<section className="map-section">
  <h3>Location</h3>
  <div className="map-card">
    <img src="/images/kothata2.jpg" alt="Kothota Aerial View" className="map-image" />
    <div className="map-info">
      <h4>INDIA, KOTHOTA</h4>
      <p>
        H.No. 3-74, Kothota, Mutyala Palli,<br />
        Mogalthuru, West Godavari, Andhra Pradesh – 534281
      </p>
    </div>
    <div className="map-embed">
      <iframe
        title="Sharanga Aqua Farms Location"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3832.376894862042!2d81.51302407494067!3d16.426038484297894!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a37f401d5d01591%3A0x6d0a5aee7f62e95!2sKothota%2C%20Andhra%20Pradesh%20534281!5e0!3m2!1sen!2sin!4v1718112345678"
        width="100%"
        height="300"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  </div>
</section>

    </div>
  );
}

export default Contact;
